import React from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Map from '../components/map/ClientMap';
import Modal from '../components/Modal';
import HeadToolbar from '../components/client/HeadToolbar';
import Fab from '@material-ui/core/Fab';
import HomeIcon from '@material-ui/icons/Home';
import {
    getHomeTrails,
    showHomeGeoJsonOnMap,
} from '../store/presentationActions';
import { connect } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    homeIcon: {
        position: 'absolute',
        left: theme.spacing(6),
        top: theme.spacing(9),
        zIndex: 1,
    },
}));

function ClientLayout(props) {
    const classes = useStyles();
    const history = useHistory();
    const params = useParams();
    const { initCollection, previewCollection } = props;
    let homeButton;
    if (params.uuid) {
        homeButton = (
            <Fab
                color="secondary"
                size="medium"
                className={classes.homeIcon}
                onClick={() => {
                    history.push('/');
                    initCollection();
                    previewCollection();
                }}
            >
                <HomeIcon />
            </Fab>
        );
    }
    return (
        <>
            <div className="app">
                <div className="app__header">
                    <HeadToolbar />
                </div>
                <div className="app__content">
                    <div className="app__map">
                        <Map />
                        {homeButton}
                    </div>
                    <div className="app__sidebar">{props.children}</div>
                </div>
            </div>
            <Modal />
        </>
    );
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        initCollection: () => dispatch(getHomeTrails()),
        previewCollection: () => dispatch(showHomeGeoJsonOnMap()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientLayout);
